package ru.it_mozaika.sender.js.application.routes

import js.core.jso
import react.create
import react.router.RouteObject
import ru.it_mozaika.sender.js.application.context.CategoriesProvider
import ru.it_mozaika.sender.js.application.frames.catalog.CatalogFrame
import ru.it_mozaika.sender.js.application.frames.catalog.ProductFrame

val catalogRoutes = jso<RouteObject> {
        path = "catalog"
        children = arrayOf (
                jso {
                        path = ":id"
                        element = CategoriesProvider.create{ ProductFrame{} }
                },
                jso{
                        path = ""
                        element = CategoriesProvider.create{
                                CatalogFrame{}
                        }
                }
        )

}